import styled from '@emotion/styled';

import IconClose from '@/assets/icons/icon-close.svg';

export const ReviewImageModal = styled.div`
  position: fixed;
  z-index: 9999;
  height: 100%;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: black;

  .close-btn {
    position: absolute;
    cursor: pointer;
    z-index: 2;
    top: 24px;
    left: 16px;
    background-image: url(${IconClose});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 24px;
    height: 24px;
  }
`;

export const FlickingWrapper = styled.div`
  position: relative;
  width: 100%;

  .flicking-viewport {
    overflow: hidden;
    height: 100%;
  }

  .flicking-camera {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 100%;
  max-height: calc(100vh - 160px);

  @media (max-width: 600px) {
    max-height: 600px;
  }
`;

export const ModalImageIndex = styled.div`
  position: absolute;
  z-index: 1;
  top: 12px;
  right: 24px;
  display: inline-flex;
  border-radius: 40px;
  padding: 2px 12px;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalImage = styled.div`
  height: 100%;
`;

export const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  -webkit-user-drag: none;
`;

export const ReviewMeta = styled.div`
  margin-left: 16px;
  display: flex;
  gap: 8px;
  z-index: 2;
  position: fixed;
  bottom: 20px;
`;
